import styled from "@emotion/styled";

import { useSearch } from "@skilitics/designer-ui-components";
import type { InteractModuleListItem } from "@skilitics/nautilus-endpoint-definition";

import { useLandingPageSettings } from "../../../LandingPageSettingsContext";
import { getModulePathDescriptor } from "../../../shared";
import { Folder } from "./Folder";
import { cardGap } from "./GridCardElements";
import { GridItem } from "./GridItem";

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-content: flex-start;
  gap: ${cardGap}px;

  width: 100%;
  height: 100%;

  padding: var(--page-padding);

  overflow: visible;
`;

const Spacer = styled.div`
  width: 100%;
  height: 1px;
`;

type Props = {
  modules: InteractModuleListItem[];
};

export const GridView = ({ modules }: Props) => {
  const { filteredData, results } = useSearch<InteractModuleListItem>();

  const { getFilterSet } = useLandingPageSettings();

  const addedFolders: string[] = [];

  return (
    <>
      <Container>
        {/* TODO: awaiting final design for location of <AddButton /> */}
        {modules.map((module) => {
          const filterPath = getFilterSet("folder")?.metadata as string;

          const { filter, isLeaf, title } = getModulePathDescriptor(module, filterPath);

          if (filter && !isLeaf) {
            if (!addedFolders.includes(filter)) {
              addedFolders.push(filter);

              const moduleCount = filteredData?.filter((mod) => mod.title.startsWith(filter)).length;
              const searchCount = results?.filter((mod) => mod.title.startsWith(filter)).length;

              return (
                <Folder
                  key={module.title}
                  title={title}
                  filter={filter}
                  moduleCount={moduleCount}
                  searchCount={searchCount}
                />
              );
            }

            return null;
          }

          return <GridItem key={module.id} module={module} title={title} />;
        })}
      </Container>
      <Spacer />
    </>
  );
};
